import { memo } from "react";

const NotificationsCloseIcon = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3334 9.99984C18.3334 14.6023 14.6025 18.3332 10 18.3332C5.39752 18.3332 1.66669 14.6023 1.66669 9.99984C1.66669 5.39734 5.39752 1.6665 10 1.6665C14.6025 1.6665 18.3334 5.39734 18.3334 9.99984ZM7.47502 7.47484C7.59221 7.3578 7.75106 7.29205 7.91669 7.29205C8.08231 7.29205 8.24117 7.3578 8.35835 7.47484L10 9.1165L11.6417 7.47484C11.7602 7.36444 11.9169 7.30433 12.0788 7.30719C12.2407 7.31005 12.3952 7.37564 12.5097 7.49015C12.6242 7.60466 12.6898 7.75915 12.6927 7.92107C12.6955 8.08299 12.6354 8.23969 12.525 8.35817L10.8834 9.99984L12.525 11.6415C12.6354 11.76 12.6955 11.9167 12.6927 12.0786C12.6898 12.2405 12.6242 12.395 12.5097 12.5095C12.3952 12.624 12.2407 12.6896 12.0788 12.6925C11.9169 12.6953 11.7602 12.6352 11.6417 12.5248L10 10.8832L8.35835 12.5248C8.23987 12.6352 8.08317 12.6953 7.92125 12.6925C7.75933 12.6896 7.60485 12.624 7.49034 12.5095C7.37583 12.395 7.31023 12.2405 7.30737 12.0786C7.30452 11.9167 7.36462 11.76 7.47502 11.6415L9.11669 9.99984L7.47502 8.35817C7.35798 8.24098 7.29224 8.08213 7.29224 7.9165C7.29224 7.75088 7.35798 7.59203 7.47502 7.47484Z"
      fill="#637381"
    />
  </svg>
);
export default memo(NotificationsCloseIcon);
